import $appConfig from "servicestack/config";
import Media from "webutils/media/media";
import DownloadImagesPrompt from "emun.cart/download-cart-images-prompt";
import Product from "emun.shopping/product.model";
import cartConfig from "emun.cart/cart.config";

const { moment } = window;

const fieldNames = ["overlayIds", "underlayIds"];

export default class CartItem {
	constructor(dto) {
		Object.assign(this, dto);
		this.optionIndex = {};
		this.todayDate = new Date();
		this.product = new Product(
			dto.product || { unlisted: true, id: dto.productId }
		);
		this.availableQty = this.product.availableQty;
		this.origQty = dto.qtyPurchased;
		if (!dto.shipOn && dto.cartItemShipOn) {
			dto.shipOn = dto.cartItemShipOn;
		}
		if (!dto.cancelOn && dto.cartItemCancelOn) {
			dto.cancelOn = dto.cartItemCancelOn;
		}

		if (dto.cartItemShipOn && moment) {
			this.$shipOn = dto.cartItemShipOn;
			this.$$shipOn = moment.utc(dto.cartItemShipOn).startOf("day");
			this.shipOnMoment = this.$$shipOn.format(cartConfig.dateFormat);
			this.origShipDate = dto.cartItemShipOn;
			//this.shipOn = moment.utc(dto.shipOn);  BL commented out 3/16/2020 due to some weird refresh issues with ship date on the cart-list-item-details.htm
		}
		if (dto.shipOn && moment) {
			this.$shipOn = dto.shipOn;
			this.$$shipOn = moment.utc(dto.shipOn).startOf("day");
			this.shipOnMoment = this.$$shipOn.format(cartConfig.dateFormat);
			this.origShipDate = dto.shipOn;
			//this.shipOn = moment.utc(dto.shipOn);  BL commented out 3/16/2020 due to some weird refresh issues with ship date on the cart-list-item-details.htm
		}
		if (dto.cartItemCancelOn && moment) {
			this.$cancelOn = dto.cartItemCancelOn;
			this.$$cancelOn = moment.utc(dto.cartItemCancelOn).startOf("day");
			this.cancelOnMoment = this.$$cancelOn.format(cartConfig.dateFormat);
			this.origCancelDate = dto.cartItemCancelOn;
			//this.shipOn = moment.utc(dto.shipOn);  BL commented out 3/16/2020 due to some weird refresh issues with ship date on the cart-list-item-details.htm
		}
		if (dto.cancelOn && moment) {
			this.$cancelOn = dto.cancelOn;
			this.$$cancelOn = moment.utc(dto.cancelOn).startOf("day");
			this.cancelOnMoment = this.$$cancelOn.format(cartConfig.dateFormat);
			this.origCancelDate = dto.cancelOn;
			//this.shipOn = moment.utc(dto.shipOn);  BL commented out 3/16/2020 due to some weird refresh issues with ship date on the cart-list-item-details.htm
		}
		if (dto.esaDate && moment) {
			this.$esaDate = dto.esaDate;
			this.esaDate = moment.utc(dto.esaDate);
		}
		(this.options || []).forEach((option) => {
			if (option.fieldId === "CompositeImages") {
				try {
					this.compositeImages = JSON.parse(option.valueId).map(
						(url) => new Media({ url })
					);
				} catch (e) {
					console.warn("CompositeImages", e);
				}
			}
			if (option.fieldId === "OnDemand") {
				try {
					this.designMap = JSON.parse(option.valueId);
				} catch (e) { }
			}
			if (option.fieldId.startsWith("customizer.")) {
				this.renderingId = this.optionIndex.RenderingId = option.valueId;
				this.renderingUrl = $appConfig.rendering(option.valueId);
			}
			this.optionIndex[option.fieldId] = option;
		});
		this.img = this.getImageUrl;
			// console.debug("CartItem", { ci: this, dto });
	}
	unitsInStock({ transactionType = {} } = {}) {
		const { product = {} } = this;
		// HKF050
		return +(transactionType && transactionType.isContainer
			? product.ovSeaInStock
			: product.unitsInStock);
	}
	availability({ transactionType = {} } = {}) {
		const { product = {} } = this;
		// HKF050
		return (
			product[
			(transactionType && transactionType.isContainer
				? "foreign"
				: "domestic") + "Availability"
			] || { HKF050: 1 }
		);
	}
	shipOnFormatted() {
		//https://emun1.monday.com/boards/333027351/pulses/775852719
		const shipOn = moment.utc(this.shipOn).startOf("day");
		const today = moment.utc(this.todayDate).startOf("day");
		return +shipOn == +today ? "ASAP" : shipOn.toDate();
	}
	isOnDemand() {
		return (
			this.options &&
			(this.optionIndex.ImageUrl ||
				this.optionIndex.CustomUrl ||
				this.designMap ||
				this.compositeImages ||
				this.renderingId)
		);
	}
	downloadPrompt(ext) {
		return DownloadImagesPrompt({
			subTitle: this.productId + " - " + this.description,
			id: this.id || this.cartId,
			productId: this.productId,
			position: this.position,
		});
	}
	getDownloadFileName(ext) {
		return `${this.productId || "Image"}.${ext || $appConfig.defaultProductImgType
			}`;
	}
	getImageFileName(size, ext) {
		return `${size || $appConfig.defaultProductSize}.${ext || $appConfig.defaultProductImgType
			}`;
	}
	getImageUrl(size, ext) {
		let slug = `${this.getImageFileName(size, ext)}?${$appConfig.cacheBuster
			}=no-cache`;
		if (this.compositeImages && this.compositeImages.length)
			return this.compositeImages[0].img(size);
		if (this.designMap) {
			for (var areaId in this.designMap) {
				let design = this.designMap[areaId];
				let isLoom32Design =
					design.url.indexOf("emun-on-demand.s3.amazonaws.com/designs/mw141") >=
					0;
				if (!isLoom32Design) {
					if (size === "hires" || size === "High-Res")
						return design.url.replace("design.json", slug);
					for (var i = 0; i < fieldNames.length; i++) {
						let fieldName = fieldNames[i];
						if (Array.isArray(design[fieldName])) {
							for (var ii = 0; ii < design[fieldName].length; ii++) {
								let id = design[fieldName][ii];
								if (id && id.length) {
									return design.url.replace("design.json", `${id}/${slug}`);
								}
							}
						}
					}
					return design.url.replace("design.json", slug);
				}
			}
		}
		if (this.optionIndex.CustomUrl) return this.optionIndex.CustomUrl.valueId;
		if (this.optionIndex.ImageUrl)
			return this.optionIndex.ImageUrl.valueId
				.replace("flat/hires", size)
				.replace("hires", size);
		if (this.renderingId)
			return $appConfig.renderingImage(this.renderingId, size);
		if (this.product && this.product.img) return this.product.img(size);

		return $appConfig.productImage(this.productId, size);
	}
}
